export default __webpack_public_path__ + "static/media/memo_doc_excel.b0bb33e0.svg";